import React, {useEffect, useState} from 'react';

import SpinnerDiv from "ui/SpinnerDiv";
import ReadOnlyInput from "ui/ReadOnlyInput";
import BootstrapRow from "ui/BootstrapRow";

const ChildBasicHeaderForm = ({child_id}) =>
{
    const [child, setChild] = useState({loading: true, data: []});

    useEffect(() => {
        getDataUsingChildId( child_id );
    }, []);
    const getDataUsingChildId = (child_id) =>
    {
        $.ajax({
            type: 'GET',
            url: Globals.APIFolder + '/children/' + child_id,
            data: {},
            success: (data) => {
                if (checkError(data))
                {
                    const childrec = data.data[0];

                    setChild({loading: false, data: childrec});
                }
            },
            error: (jqXHR, textStatus, error) => {
                handleAjaxError(jqXHR, textStatus, error);
            }

        });
    }

    if (child.loading === true)
    {
        return (<SpinnerDiv/>);
    }
    else
    {
        return <div className='panel panel-default'>
            <div className='panel-body'>
                <BootstrapRow>
                    <div className='col-md-6'>
                        <ReadOnlyInput label='First Name' value={child.data.firstname}/>
                    </div>
                    <div className='col-md-6'>
                        <ReadOnlyInput label='Last Name' value={child.data.surname}/>
                    </div>
                </BootstrapRow>
            </div>
        </div>
    }
}

export default ChildBasicHeaderForm;

